var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Carousel',{attrs:{"settings":_vm.carouselSettings}},_vm._l((_vm.recommendedProducts),function(ref){
var product = ref.product;
var experiment = ref.experiment;
return _c('div',{key:product.id,staticClass:"px-1 text-left align-self-stretch d-flex align-items-stretch text-decoration-none"},[_c('Product',{attrs:{"product":product,"experiment":experiment,"feature":_vm.feature}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }